import { useParams, useSearchParams } from 'react-router-dom';

import ChainIcon from '@/icons/ChainIcon.svg?react';
import LLMIcon from '@/icons/LLMIcon.svg?react';
import ToolIcon from '@/icons/ToolIcon.svg?react';

import { Breadcrumb } from '../../components/Breadcrumbs';
import {
  appPublicDatasetsPath,
  appPublicPath,
  appRunPath,
  appSessionPath,
} from '../../utils/constants';
import { useRootRunAndRun } from '../Run/utils/useRootRunAndRun';

export function PublicDatasetRunCrumb() {
  const { datasetShareToken, runId, sessionId } = useParams();
  const [searchParams] = useSearchParams();
  const traceId = searchParams.get('trace_id') ?? undefined;
  const { rootRun, run } = useRootRunAndRun(traceId, runId, {
    datasetShareToken,
  });
  const hasEllipsis =
    runId &&
    run?.data?.parent_run_id &&
    run?.data?.parent_run_id !== rootRun?.id;

  const runList = [rootRun ?? undefined, hasEllipsis ? null : undefined];
  if (runId && rootRun?.id !== runId && run.data) {
    runList.push(run.data);
  }

  return runList.map((runOrEllipsis) => {
    if (runOrEllipsis === undefined) {
      return null;
    }
    if (runOrEllipsis === null) {
      return <Breadcrumb key="ellipsis" path="#" name="..." />;
    }
    const { id, name, run_type } = runOrEllipsis;
    let icon = <ChainIcon />;

    if (run_type === 'llm') {
      icon = <LLMIcon />;
    } else if (run_type === 'tool') {
      icon = <ToolIcon />;
    }

    return (
      <Breadcrumb
        key={id}
        path={`/${appPublicPath}/${datasetShareToken}/${appPublicDatasetsPath}/${sessionId}/${appSessionPath}/${appRunPath}/${id}?trace_id=${
          rootRun?.id
        }${rootRun?.start_time && `&start_time=${rootRun.start_time}`}`}
        icon={icon}
        name={name}
        isActive={id === runId || (runId == null && id === rootRun?.id)}
      />
    );
  });
}
